<template>
    <form v-show="isInputFormActive" method="POST">
        <div class="row d-flex align-items-end">
            <div class="col-lg-6 col-md-6 col-12">
                <div class="form-group">
                    <input
                        v-model="court.name"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid' : court.error }"
                        id="court-name"
                        name="court-name"
                        aria-describedby="Court Name"
                        placeholder="Court Name"
                    />
                    <span v-if="court.error" class="invalid-feedback" role="alert">
                        <strong>Field is Required</strong>
                    </span>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
                <div class="form-group">
                    <label for="account-number"></label>
                    <input
                        v-model="accountNumber"
                        type="text"
                        class="form-control"
                        id="account-number"
                        name="account-number"
                        aria-describedby="Account Number"
                        placeholder="Account Number"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="court-address">
                        Address
                    </label>
                    <input v-model="court.address" type="location" class="form-control required" id="court-address" name="court-address">
                </div>
            </div>

            <div class="col-md-3">
                <div class="form-group">
                    <label for="court-city">
                        City
                    </label>
                    <input v-model="court.city" type="text" class="form-control required" id="court-city" name="court-city">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="court-state">
                        State
                    </label>
                    <Select2
                        id="court-state"
                        name="court-state"
                        v-model="court.state"
                        :options="stateStore.select2State()"
                    />
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="court-zipcode">
                        Zipcode
                    </label>
                    <input v-model="court.zipcode" type="text" class="form-control" id="court-zipcode" name="court-zipcode">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <router-link
                    :to="{ name: 'disputes-report'}"
                    class="btn btn-primary btn-submit mr-50" target="_self"
                    v-if="userStore.user.isDiy"
                >
                Back
                </router-link>
                <a :href="$router.resolve({ name: 'disputes-report'}).href" class="btn btn-primary btn-submit mr-50" v-else>Back</a>
                <button @click="submitForm" type="button" class="btn btn-outline-primary btn-submit">Submit</button>
            </div>
        </div>
    </form>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                            <div class="row">
                                <div class="col-12">
                                    <h4>APPEND CLIENT DOCUMENTS</h4>
                                    <div class="display-box mb-1">
                                        <div class="ml-2">
                                            <input
                                                class="custom-control-input"
                                                type="checkbox"
                                                name="append_affidavit"
                                                value="1"
                                                tabindex="4"
                                                v-model="checkbox"
                                                id="append_affidavit"

                                            />
                                            <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                ID Theft Affidavit
                                            </label>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <form class="row">
                                <input type="hidden" name="_token" :value="csrf">
                                <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="court.name" hidden>
                                <div class="col-md-12">
                                    <editor
                                        id="couteHouseletter"
                                        v-model="couteHouseletter"
                                        :api-key="settingStore.tinymce.api_key"
                                        :init="settingStore.tinymce.configuration"
                                    />
                                    <div class="d-flex justify-content-center my-1">
                                        <button class="btn btn-sm-block btn-primary" type="button" name="editorType" value="1" @click.once="createLetter()">
                                            {{ localizationStore.translate("letter.left.submit.button.text") }}
                                        </button>
                                        <button
                                            id="letter-rewrite"
                                            class="btn btn-outline-primary ml-1"
                                            @click="spin"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.letter.button.text") }}
                                            <b-popover
                                                target="letter-rewrite"
                                                placement="top"
                                                triggers="hover"
                                                :html="true"
                                            >
                                                <template #title>
                                                    {{ localizationStore.translate("chat.pricing.title") }}
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                            {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                        </p>
                                                        <p v-else>
                                                            {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </b-popover>
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#chat-modal"
                                            class="btn btn-outline-primary mx-1"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("chat.button.title") }}
                                        </button>
                                        <button
                                            data-toggle="modal"
                                            data-target="#top-up-modal"
                                            class="btn btn-outline-primary"
                                            type="button"
                                        >
                                            {{ localizationStore.translate("spin.purchase.button.text") }}
                                        </button>
                                    </div>

                                <div class="row">
                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRef' />
                                </div>
                                </div>
                            </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRef" hidden>
            <div class="page">
                <p>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                    <br />
                    {{ userInfo.address }}
                    <br/>
                    {{ userInfo.city }}, {{ userInfo.state }} {{ userInfo.zipcode }}
                    <br>
                    {{ userInfo.dob }}
                    <br>
                    {{ userInfo.ssn }}
                    <br>
                    <br>
                    {{ court.name }}
                    <br>
                    {{ court.address }}
                    <br>
                    <br>
                    Date: {{ userInfo.tdate }}
                    <br>
                    <br>
                    <template v-if="court.name">
                        RE: Reporting To The {{ court.name }}
                    </template>
                    <br>
                </p>
                <p>
                    To Whom It May Concern:
                </p>
                <p class="letter-content">
                    I received a copy of my credit report about the bankruptcy below.
                </p>
                <p>
                    {{ accountNumber }}
                </p>
                <p class="letter-content">
                    I was told from all 3 credit reporting agencies that you guys report Bankruptcy to the 3 credit reporting agencies Experian.Transunion, and Equifax. If so that is a private matter Especially if you didnt report it. Any account thats reporting on a consumer creditm report must list the agency who is reporting it and you guys name is listed as reporting it to the credit reporting agencies. Can you guys please reach out to me and let me know if this is true please. As i know thats forgery of your name onto my credit report if you didnt report it directly as the furnisher.
                </p>
                <p class="letter-content">
                    Thank you for your time and help in this matter.
                </p>
                <p style="page-break-after: always;">
                    Sincerely, <br> <br>
                    {{ userInfo.firstname }} {{ userInfo.lastname }}
                </p>
            </div>
            <div class="page-content">
                <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
                <p style="padding-top:3rem; text-align: center;">
                    <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                    <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
                </p>
                <p v-if='userStore.user.address_verify_image_url'>
                    <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
                </p>
            </div>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useStateStore } from '../../stores/StateStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import Select2 from 'vue3-select2-component';
  import Editor from '@tinymce/tinymce-vue'
  import { BPopover } from 'bootstrap-vue-3'
  export default {
    props: {
        csrf: {
            type: String
        },
        creditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        Select2,
        Editor
    },
    setup(props) {
        return {
            selectedCreditBureauId: ref(null),
            editorRef: ref(null),
            isInputFormActive: ref(true),
            creditBureauError: ref(false),
            couteHouseletter:ref(),
            court: reactive({
                name: null,
                address: null,
                city: null,
                state: null,
                zipcode: null,
                error: null
            }),
            accountNumber: ref(null),
            localizationStore: useLocalizationStore(),
            stateStore: useStateStore(),
            userStore: useUserStore(),
            letterStore:useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            userInfo:reactive({}),
            checkbox:ref(false),
        };
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.userInfo = value
            }
        },
    },
    created() {

    },
    mounted() {
        const $this = this;
        if(!_.isEmpty($this.userStore.user)){
            $this.userInfo = $this.userStore.user
        }else{
            $this.userStore.fetchUser();
        }
        // setTimeout(() => {
        //     $this.$nextTick().then(() => {
        //         $this.couteHouseletter = $this.$refs.editorRef && $this.$refs.editorRef.innerHTML;
        //     });
        // }, 1000);
    },
    computed: {
        // a computed getter
        selectedCreditBureau() {
            return this.creditBureaus.find((attribute) => {
                if (attribute.id == this.selectedCreditBureauId) {
                    return attribute;
                }
            })
        },
        isCreditBureauSelected() {
            return (this.selectedCreditBureauId == null || this.selectedCreditBureauId == "null") ? false : true;
        }
    },
    methods: {
      submitForm: function () {
        if (this.validate()) {
            this.couteHouseletter = this.$refs.editorRef && this.$refs.editorRef.innerHTML;
            this.isInputFormActive = !this.isInputFormActive;
        }
      },
      createLetter(){
        let $this = this;
        let params = { letter: this.$route.params.letter };
        if (this.$route.params.client) {
            params.client = this.$route.params.client
        }
        if (this.$route.params.team) {
            params.team = this.$route.params.team
        }
        const createLetterRoute = this.$router.resolve({
            name: 'create-letter',
            params: params
        });
        let payload = {
            'letter_id' : this.letterStore.getId(this.$route.params.letter),
            'creditbureau' : this.court.name,
            'editor' : this.couteHouseletter,
            'editorType':1,
            append_affidavit : $this.checkbox,
        }
        axios.post(createLetterRoute.href, payload)
        .then(function (response) {
            if(response.data.error == true) {
                toastr.error(response.data.message, 'Error!');
                return;
            }
            toastr.success(response.data.message, 'Success!');
            setTimeout(() => {
                if($this.userStore.user.isDIY){
                    $this.$router.push({ name: 'disputes-report' });
                    return;
                }
                window.location.href = response.data.data.url;
            }, 3000)
        })
        .catch(function (error) {
            console.log(error);
        });


      },
      goBack: function () {
        this.isInputFormActive = !this.isInputFormActive;
      },
      validate: function () {
        if (this.court.name == null || this.court.name == "null") {
            this.court.error = true;
        }
        else {
            this.court.error = false;
        }
        return !this.court.error;
      },
      spin() {
        this.$refs.spinner.spin(tinymce.get('couteHouseletter'))
      },
      changeCheckbox(){
            this.checkbox = !this.checkbox
      }
    }
  };
</script>
